<template>
  <div id="page-contact">
    <div class="flex flex-wrap -mr-4">
      <!-- Information - Col 1 -->
      <div class="vx-col flex-1" id="account-info-col-1">
        <table>
          <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Firma</th>
            <th>Subskrypcja</th>
            <th>Aktywne do</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(user, index) in users" :key="index" style="border: 2px solid black;">
            <td>{{ user.id }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.company }}</td>
            <td>{{ user.status }}</td>
            <td>
              <flat-pickr
                  v-model="user.active_to"
                  placeholder="Aktywne do"
                  class="mt-5"
                  disabled
                  :config="configdateTimePicker"
                  @on-change="dateSelection(index)"
              />
            </td>
            <td>
              <button type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled" @click="togglePopup(index)" style="margin-top: 15px;">
                <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                <span class="vs-button-text vs-button--text">Login as</span>
                <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
              </button>
            </td>
            <td>
              <button type="button" name="button" class="vs-component vs-button vs-button-warning vs-button-filled" @click="togglePasswordPopup(index)" style="margin-top: 15px;">
                <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                <span class="vs-button-text vs-button--text">Change password</span>
                <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- popup -->
    <vs-popup class="holamundo" class-content="flex items-center justify-center" title="Add Master Password" :active.sync="popupActive">
      <vs-input placeholder="Master Password" v-model="password" class="w-1/2"/>
      <vs-button @click="login()" class="ml-2">Login as</vs-button>
    </vs-popup>

    <vs-popup class="holamundo" class-content="flex items-center justify-center" title="Add Master Password and new user password" :active.sync="popupPasswordActive">
      <vs-input placeholder="Master Password" v-model="password" class="w-1/2"/>
      <vs-input placeholder="New user password" v-model="newPassword" class="ml-2 w-1/2"/>
      <vs-button @click="changePassword()" :disabled="newPassword.length < 8 || !password.length" class="ml-2 w-1/2">Change password</vs-button>
    </vs-popup>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Polish as PolishLocale} from 'flatpickr/dist/l10n/pl.js';
import vSelect from "vue-select";
import auth from '@/auth/authService';

export default {
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  data() {
    return {
      users: [],
      oldUsers: [],
      subscriptions: [],
      configdateTimePicker: {
        locale: PolishLocale,
      },
      changed: [],
      popupActive: false,
      index: null,
      password: '',
      newPassword: '',
      popupPasswordActive: false,
    }
  },
  computed: {},
  methods: {
    fetchAll() {
      let url = process.env.VUE_APP_API_ENDPOINT + '/v1/users';
      this.$http.get(url).then(response => {
        console.log('response', response)
        this.users = response.data.users;
      });
    },

    login() {
      let userData = this.users[ this.index ]
      let password = this.password;

      let requestObject = {
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/auth/login',
        method: 'post',
        data: {
          email: userData.email,
          password: password
        }
      }
      this.$http.request(requestObject).then(response => {
        if (response) {
          this.popupActive = false;
          auth.localLogin(response.data.data);
          location.href = '/';
        } else {
          this.$vs.dialog({
            color: 'warning',
            title: `Błąd`,
            text: 'Wystąpił błąd podczas zapisywania. Spróbuj jeszcze raz lub skontaktuj się z administratore,',
            acceptText: 'Akceptuj',
            accept: this.acceptAlert
          })
        }
      });
    },
    togglePopup(index) {
      this.index = index;
      this.popupActive = !this.popupActive;
    },
    togglePasswordPopup(index) {
      this.index = index;
      this.popupPasswordActive = !this.popupPasswordActive;
    },
    checkAdmin() {
      return this.$store.state.AppActiveUser.is_admin > 0 || this.$store.state.AppActiveUser.id == 1;
    },
    dateSelection(index) {
      if(this.users[index].active_to != this.oldUsers[index].active_to) {
        if (!this.changed.includes(index)) {
          this.changed.push(index);
        }
      } else {
        const key = this.changed.indexOf(index);
        if(key >= 0) this.changed.splice(key, 1);
      }
    },
    resetPassword() {
      this.password = '';
      this.newPassword = '';
    },
    changePassword() {
      const userData = this.users[ this.index ]
      const data = {
        password: this.password,
        newpassword: this.newPassword,
      }
      const jsonString = JSON.stringify(data);
      const base64Data = btoa(jsonString);

      let requestObject = {
        url: process.env.VUE_APP_API_ENDPOINT + '/v1/user-password/' + userData.id,
        method: 'post',
        data:{ data: base64Data }
      }
      this.$http.request(requestObject).then(response => {
        if (response.data.data === true) {
          this.$vs.dialog({
            color: 'success',
            title: `Wiadomość`,
            text: 'Hasło uaktualnione',
            acceptText: 'Akceptuj',
            accept: this.acceptAlert
          })
        } else {
          this.$vs.notify({
            title:'Błąd',
            text: response.data.errors[0].title,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
        this.popupPasswordActive = false;
        this.resetPassword();
      });
    },
  },
  created() {
    if(this.checkAdmin()) {
      this.fetchAll()
    } else {
      this.$router.push('/').catch(() => {})
    }
  },
}
</script>
